export class Message {
    class: string;
    message: string | [];
}
